import React from 'react';

import ImageUploading from "react-images-uploading";

//styles
import styles from "./UploadFileImages.module.css"

//images
import addIcon from "../../../../assets/img/DashboardICons/CircleAddIconBlue.svg"
import portraitIcon from "../../../../assets/img/DashboardICons/PortraitIcon.svg"
import trashIcon from "../../../../assets/img/DashboardICons/TrashIcon.svg"

const UploadFileImages = (props) => {
    const maxNumber = 30;
    const onChange = (imageList, addUpdateIndex) => {
        // console.log(imageList, addUpdateIndex);
        props.setImages(imageList);
        // const test = await props.image
        //  console.log(imageList)
    };
    return (
        <>
            <div className="py-2">
                <div className="container-fluid">
                    <div
                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                        dir="rtl"
                    >
                        <div className='d-flex flex-column justify-content-center align-items-start flex-wrap'>
                            <div className={`mb-4 ${styles.title_bold}`}>
                                افزودن عکس
                            </div>
                            <div className="d-flex align-items-center justify-content-center mb-5">
                                <div className={`ms-2 ${styles.circle_green}`}></div>
                                <div className={styles.title_sm_gray}>
                                    حداکثر تا ۳۰ عکس میتوانید انتخاب کنید
                                </div>
                            </div>
                            <ImageUploading
                                multiple
                                value={props.images}
                                onChange={onChange}
                                maxNumber={maxNumber}
                                dataURLKey="data_url"
                            // maxFileSize={500000}
                            // fileSizeError="حجم عکس ها نباید بیشتر از 500 کیلوباید باشد"
                            >
                                {({
                                    imageList,
                                    onImageUpload,
                                    onImageRemove,
                                    dragProps
                                }) => (
                                    <div className='w-100 d-flex align-items-center flex-wrap'>
                                        {imageList?.map((image, index) => (
                                            <div key={index} className={`d-flex flex-column align-items-center justify-content-center my-4 ms-4 ${styles.uploaded_img_container}`}>
                                                <img className={styles.uploaded_img} src={image['data_url']} alt="uploaded-img" />
                                                <div className={styles.remove_img_container}>
                                                    <img onClick={() => onImageRemove(index)} src={trashIcon} alt="icon" />
                                                </div>
                                            </div>
                                        ))}

                                        <div className={`d-flex align-items-center justify-content-center ${styles.upload_img_container}`}>
                                            <div className="d-flex flex-column align-items-center justify-content-center position-relative">
                                                <img src={portraitIcon} alt="icon" />
                                                <img className={styles.add_icon} src={addIcon} alt="icon" onClick={onImageUpload}
                                                    {...dragProps} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </ImageUploading>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UploadFileImages;